module.exports = __webpack_public_path__ + "static/media/nav_card_icon_2.c2f8f88d.svg";